import { BREAKPOINT, TableConfig, TableLayout } from '@spartacus/storefront'
import { EbProductVariantsTableActionsComponent } from './eb-product-variants-table-actions.component'

export const ebVariantsTableConfig: TableConfig = {
  table: {
    variants: {
      cells: ['actions'],
      options: {
        layout: TableLayout.VERTICAL,
        cells: {
          actions: {
            label: ' ',
            dataComponent: EbProductVariantsTableActionsComponent
          }
        }
      },
      [BREAKPOINT.md]: {
        options: { layout: TableLayout.VERTICAL_STACKED }
      },
      [BREAKPOINT.sm]: {
        options: { layout: TableLayout.VERTICAL_STACKED }
      },
      [BREAKPOINT.xs]: {
        options: { layout: TableLayout.VERTICAL_STACKED }
      }
    }
  }
}

export function ebVariantsTableConfigFactory(): TableConfig {
  return ebVariantsTableConfig
}
